export default __webpack_public_path__ + "static/heroGraphic-131241d63f79ae8d6a565126945ca6e9.png";